import { useTheme } from '@mui/material';
import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const faqData = {
  mainText: `FAQs`,
  description: `Learn more about Synthetic Data Generation with Rumble Fish`,
};

export const AccordionData = (): IAccordionData[] => {
  const theme = useTheme();
  return [
    {
      title: 'Q: What is synthetic data?',
      customDescription: () => (
        <>
          A: Synthetic data is artificially generated information that mimics
          the statistical properties, patterns, and relationships of real data
          without containing any actual sensitive information. Think of it as
          creating realistic "fake" data that behaves like the real thing.
          <br />
          <br />
          For example, in the Panenka project, we generated thousands of player
          names and faces that look and feel authentic, but none of them are
          real people. The names sound culturally appropriate for their
          countries of origin, the faces look photorealistic and age naturally
          over time, yet no actual person's data or likeness was used.
          <br />
          <br />
          The key difference from simple "dummy data" or "mock data" is
          sophistication: synthetic data preserves complex relationships,
          statistical distributions, and realistic variations that make it
          suitable for training AI models, thorough testing, and meaningful
          analysis, not just filling database fields with random values.
        </>
      ),
      gradientOnFocus: theme.mixins.aquamarineGradient?.background as string,
    },
    {
      title: `Q: How is this different from Gretel, MOSTLY AI, or Tonic?`,
      description: `
        
          A: Those are platforms - you configure their pre-built generators.
          We're custom engineering - we build solutions tailored to your
          specific requirements. When Panenka needed culturally diverse names
          and aging faces, no platform could deliver that. We engineered it from
          scratch.
        
      `,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
    {
      title: `Q: Do we need to be technical to work with you?`,
      description: `
        
          A: No. We handle all the technical complexity. You bring product
          vision and requirements; we bring engineering expertise and ownership.
        
      `,
      gradientOnFocus: theme.mixins.greenGradient?.background as string,
    },
    {
      title: `Q: What if our requirements change mid-project?`,
      description: `
        
          A: We expect this. Our agile, iterative process with daily stand-ups
          means we adapt quickly. For Panenka, we pivoted our approach when
          Leonardo.ai initially struggled; flexibility is built into our
          methodology.
        
      `,
      gradientOnFocus: theme.mixins.aquamarineGradient?.background as string,
    },
    {
      title: `Q: What do we get at the end?`,
      description: `
        
          A: Complete ownership of the solution: source code, documentation,
          trained models, and full integration with your systems. Plus ongoing
          support if needed.
        
      `,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
  ];
};
